exports.BaseBinGeometry = class BaseBinGeometry {
  constructor(bin, container) {
    this.bin = bin;
    this.container = container;
  }

  get isCircular() {
    return false;
  }

  get totalHeight() {
    return this.bin.dimensions.totalHeight;
  }

  get totalVolume() {
    return this.bin.volumes.total;
  }

  /* eslint-disable no-unused-vars */
  distanceToBin([x, y, z]) {
    throw new Error('Not implemented: distanceToBin');
  }

  isPointInsideBin([x, y, z]) {
    const [minZ, maxZ] = this.container.zIntercepts(x, y);
    if (!Number.isFinite(minZ) || !Number.isFinite(maxZ)) {
      return false;
    }
    return z >= minZ && z <= maxZ;
  }

  /**
   * Returns a 3D vector representing the point that the top of the bracket attaches to the bin.
   * Co-ordinate system for this method: [0, 0, 0] is the center of the bottom of the hopper, positive z is up toward the top of the bin
   * @returns {[number, number, number] | undefined} [x, y, z] in meters
   */
  bracketAttachmentPoint() {
  }

  /**
   * Returns a point representing the midpoint of the sensor in the bin's co-ordinate system
   * @returns {[number, number, number]} [x, y, z] in metres
   */
  sensorMidpoint() {
    throw new Error('Not implemented: sensorMidpoint');
  }

  /**
   * Returns the amount the bracket is rotated (from normal) in radians along the z-axis
   * @returns {number} in radians
   */
  bracketRotationForBin() {
    throw new Error('Not implemented: bracketRotationForBin');
  }

  /**
   * Assuming the camera is pointed at the bottom of the hopper, computes the expected pan and tilt of the camera
   * @returns {{tilt: number, pan: number}}
   */
  estimatedCameraAngleForBin() {
    throw new Error('Not implemented: estimatedCameraAngleForBin');
  }

  /**
   * Finds the minimum and maximum feed heights for a given entry of a height map
   * @param x {number} x co-ordinate in height map
   * @param y {number} y co-ordinate in height map
   * @param resolution {number} the resolution of the height map
   * @returns {{min: number, max: number}}
   */
  feedHeightConstraint(x, y, resolution) {
    // TODO it would be a lot nicer if x, y were always continuous across the interface and the caller decides whether
    //  it wants the centrepoint of the pixel by explicitly adding 0.5 to the coords
    const [binX, binY] = this.heightMapXYCoordinateToBinCoordinate([x + 0.5, y + 0.5], resolution);
    const [minZ, maxZ] = this.container.zIntercepts(binX, binY);
    return { min: minZ || 0, max: maxZ || this.bin.dimensions.totalHeight }; // TODO should we just return undefined?
  }

  binXYCoordinateToHeightMapCoordinate([x, y], resolution) {
    throw new Error('Not implemented: binXYCoordinateToHeightMapCoordinate');
  }

  heightMapXYCoordinateToBinCoordinate([x, y], resolution) {
    throw new Error('Not implemented: heightMapXYCoordinateToBinCoordinate');
  }

  isHeightMapCoordinateInBin(x, y, resolution) {
    throw new Error('Not implemented: isHeightMapCoordinateInBin');
  }

  changeSurfaceToBinsCoordinateSystem(surface, binGeometry, tilt = 0, pan = 0) {
    throw new Error('Not implemented: changeSurfaceToBinsCoordinateSystem');
  }

  metresPerHeightMapPixel(resolution) {
    throw new Error('Not implemented: metresPerHeightMapPixel');
  }

  binWallSurface() {
    return this.container.toSurface();
  }

  binWallBoundingBox() {
    return this.container.boundingBox();
  }

  /* eslint-enable no-unused-vars */
};
